import { ElementType } from "../../library-js/dom-tools/ElementType";
import { ContextMenu } from "./ContextMenu";
import { ContextMenuItem } from "./ContextMenuItem";

export class ContextMenuEntry extends ContextMenuItem
{
  static readonly type = new ElementType<HTMLElement>( "context--menu--entry" );
  _entry:Element;

  constructor( parent:ContextMenu, entry:string|Element )
  {    
    super( parent );
    this._entry = typeof entry === "string" ? ElementType.span.create( entry ) : entry;;
    this.create();
  }

  _create():void
  {
    this._createElement( ContextMenuEntry.type, this._entry );
  }
}